// src/api/dashboardService.js
// -----------------------------------------------------------------------------
// Calls for the Dashboard & Reports screens (Requirement #23: Dashboard and
// reports for long-pending tickets, + Additional Requirement: Excel export).
// -----------------------------------------------------------------------------
import axiosClient from './axiosClient';
import ENDPOINTS from './endpoints';

const dashboardService = {
  /** Summary counts/widgets for the main dashboard (open/closed/by-severity, etc). */
  getSummary: (params = {}) => axiosClient.get(ENDPOINTS.DASHBOARD_SUMMARY, { params }),

  /** Tickets that have stayed in a non-closed status past a configurable threshold. */
  getLongPendingTickets: (params = {}) => axiosClient.get(ENDPOINTS.REPORTS_LONG_PENDING, { params }),

  /**
   * Requests a report export as an Excel file (Additional Requirement:
   * "Export of reports to Excel"). Returns a blob for download.
   */
  exportReport: (reportType, params = {}) =>
    axiosClient.get(ENDPOINTS.REPORTS_EXPORT_EXCEL, {
      params: { reportType, ...params },
      responseType: 'blob',
    }),
};

export default dashboardService;
